import React from 'react';

import { Icon } from '@ui/icons/Icon.tsx';

import { useCSSColors } from '../../../../../src/hooks/useCSSColors.ts';
import { WarningTheme } from './styles.ts';

const LeavingSecurityWarning = ({ T }) => {
  const colors = useCSSColors();
  const leavingSecurityWarning = (
    <WarningTheme data-testid="LeavingSecurityWarning" color={colors.statusWarningBackground}>
      <Icon className="icon" width={24} height={24} name="triangle-warning" cdn fillColor={colors.widgetIconFill} />
      {T('getDirectionsFromTo:This route exits security')}
    </WarningTheme>
  );
  return leavingSecurityWarning;
};

export default LeavingSecurityWarning;
